import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
/// Scroll
import PerfectScrollbar from 'react-perfect-scrollbar';
// Redux
import {connect} from 'react-redux';

import {Dropdown} from 'react-bootstrap';
import Logout from './Logout';
import {
    getNotificationToken,
    seenNotification,
} from '../../../services/Dashboard';
import avatar from '../../../images/avatar/1.jpg'


const Header = props => {
    const {userProfile} = props;
    const [showDropdown, setShowDropdown] = useState(false);
    const [setNotificationStatus] = useState('unknown'); // 'unknown', 'granted', 'denied', 'blocked'
    var path = window.location.pathname.split('/');
    var name = path[path.length - 1].split('-');
    var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
    const [notificationData, setNotificationData] = useState([]);
    const [filteredNotifications, setFilteredNotifications] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [unreadCount, setUnreadCount] = useState(0);


    const profileSrc = userProfile?.profile_img
  ? `${process.env.REACT_APP_API_RESOURCE_URL}${userProfile.profile_img}`
  : avatar;

    useEffect(() => {
        // Check if notifications are already enabled
        const checkNotificationStatus = async () => {
            if (!('Notification' in window)) {
                setNotificationStatus('unsupported');
                return;
            }

            const permission = Notification.permission;
            setNotificationStatus(permission);
        };

        checkNotificationStatus();

        // Load notifications on first render
        handleGetNotificationToken();
    }, []);

    // Filter notifications when search query changes or notification data updates
    useEffect(() => {
        if (searchQuery.trim() === '') {
            setFilteredNotifications(notificationData);
        } else {
            const lowercaseQuery = searchQuery.toLowerCase();
            const filtered = notificationData.filter(item => {
                return (
                    (item.title &&
                        item.title.toLowerCase().includes(lowercaseQuery)) ||
                    (item.message &&
                        item.message.toLowerCase().includes(lowercaseQuery)) ||
                    (item.endpoint &&
                        item.endpoint.bookid &&
                        item.endpoint.bookid
                            .toString()
                            .toLowerCase()
                            .includes(lowercaseQuery))
                );
            });
            setFilteredNotifications(filtered);
        }
    }, [searchQuery, notificationData]);

    const handleDropdownToggle = isOpen => {
        setShowDropdown(isOpen);
    };

    const handleDropdownItemClick = () => {
        setShowDropdown(false);
        localStorage.removeItem('fcmToken');
    };

    const handleGetNotificationToken = async () => {
        setSearchQuery('');
        try {
            const res = await getNotificationToken();
            if (res) {
                console.log(res);
                setNotificationData(res);
                setFilteredNotifications(res);
                // Update unread count
                const unread = res.filter(item => !item.is_seen).length;
                setUnreadCount(unread);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleNotificationClick = async notification => {
        try {
            if (!notification.is_seen) {
                // Call the API to mark the notification as seen
                await seenNotification(notification.id);

                // Update the UI
                const updatedNotifications = notificationData.map(item =>
                    item.id === notification.id
                        ? {...item, is_seen: true}
                        : item
                );
                setNotificationData(updatedNotifications);

                // Update unread count
                const newUnreadCount = updatedNotifications.filter(
                    item => !item.is_seen
                ).length;
                setUnreadCount(newUnreadCount);
            }

            // Handle navigation or other actions based on notification type if needed
            if (notification.endpoint && notification.endpoint.type) {
                // Example: navigate to specific page based on notification type
                // history.push(`/${notification.endpoint.type}/${notification.endpoint.bookid}`);
                console.log('Notification clicked:', notification.endpoint);
            }
        } catch (error) {
            console.error('Error marking notification as seen:', error);
        }
    };

    return (
        <div className='header'>
            <div className='header-content'>
                <nav className='navbar navbar-expand'>
                    <div className='collapse navbar-collapse justify-content-between'>
                        <div className='header-left'>
                            <div
                                className='dashboard_bar'
                                style={{textTransform: 'capitalize'}}
                            >
                                {filterName[0] === ''
                                    ? 'Dashboard'
                                    : filterName.join(' ')}
                                {filterName[0] === '' ? (
                                    <span>Welcome to Skippy Admin!</span>
                                ) : filterName[0] === 'reservations' ? (
                                    <span>
                                        Here is your reservation list data
                                    </span>
                                ) : filterName[0] === 'users' ? (
                                    <span>Here is your admin users list</span>
                                ) : filterName[0] === 'settings' ? (
                                    <span>
                                        Here are your restaurant settings
                                    </span>
                                ) : filterName[0] === 'food' &&
                                  filterName[1] === 'items' ? (
                                    <span>
                                        Here are your list of food items
                                    </span>
                                ) : filterName[0] === 'customers' ? (
                                    <span>Here is your customer list data</span>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <ul className='navbar-nav header-right'>
                            {/* <li className='nav-item'> */}
                            {/*     <div className='input-group search-area d-xl-inline-flex d-none'> */}
                            {/*         <input */}
                            {/*             type='text' */}
                            {/*             className='form-control' */}
                            {/*             placeholder='Search here...' */}
                            {/*         /> */}
                            {/*         <div className='input-group-append'> */}
                            {/*             <span className='input-group-text'> */}
                            {/*                 <Link to='#'> */}
                            {/*                     <i className='flaticon-381-search-2' /> */}
                            {/*                 </Link> */}
                            {/*             </span> */}
                            {/*         </div> */}
                            {/*     </div> */}
                            {/* </li> */}

                            <Dropdown
                                onClick={() => handleGetNotificationToken()}
                                className='nav-item dropdown notification_dropdown'
                                as='li'
                            >
                                <Dropdown.Toggle
                                    as='a'
                                    variant=''
                                    className='nav-link  ai-icon i-false'
                                    href='#'
                                    role='button'
                                    data-toggle='dropdown'
                                >
                                    <svg
                                        width={28}
                                        height={28}
                                        viewBox='0 0 28 28'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M21.75 14.8385V12.0463C21.7471 9.88552 20.9385 7.80353 19.4821 6.20735C18.0258 4.61116 16.0264 3.61555 13.875 3.41516V1.625C13.875 1.39294 13.7828 1.17038 13.6187 1.00628C13.4546 0.842187 13.2321 0.75 13 0.75C12.7679 0.75 12.5454 0.842187 12.3813 1.00628C12.2172 1.17038 12.125 1.39294 12.125 1.625V3.41534C9.97361 3.61572 7.97429 4.61131 6.51794 6.20746C5.06159 7.80361 4.25291 9.88555 4.25 12.0463V14.8383C3.26257 15.0412 2.37529 15.5784 1.73774 16.3593C1.10019 17.1401 0.751339 18.1169 0.75 19.125C0.750764 19.821 1.02757 20.4882 1.51969 20.9803C2.01181 21.4724 2.67904 21.7492 3.375 21.75H8.71346C8.91521 22.738 9.45205 23.6259 10.2331 24.2636C11.0142 24.9013 11.9916 25.2497 13 25.2497C14.0084 25.2497 14.9858 24.9013 15.7669 24.2636C16.548 23.6259 17.0848 22.738 17.2865 21.75H22.625C23.321 21.7492 23.9882 21.4724 24.4803 20.9803C24.9724 20.4882 25.2492 19.821 25.25 19.125C25.2486 18.117 24.8998 17.1402 24.2622 16.3594C23.6247 15.5786 22.7374 15.0414 21.75 14.8385ZM6 12.0463C6.00232 10.2113 6.73226 8.45223 8.02974 7.15474C9.32723 5.85726 11.0863 5.12732 12.9212 5.125H13.0788C14.9137 5.12732 16.6728 5.85726 17.9703 7.15474C19.2677 8.45223 19.9977 10.2113 20 12.0463V14.75H6V12.0463ZM13 23.5C12.4589 23.4983 11.9316 23.3292 11.4905 23.0159C11.0493 22.7026 10.716 22.2604 10.5363 21.75H15.4637C15.284 22.2604 14.9507 22.7026 14.5095 23.0159C14.0684 23.3292 13.5411 23.4983 13 23.5ZM22.625 20H3.375C3.14298 19.9999 2.9205 19.9076 2.75644 19.7436C2.59237 19.5795 2.50014 19.357 2.5 19.125C2.50076 18.429 2.77757 17.7618 3.26969 17.2697C3.76181 16.7776 4.42904 16.5008 5.125 16.5H20.875C21.571 16.5008 22.2382 16.7776 22.7303 17.2697C23.2224 17.7618 23.4992 18.429 23.5 19.125C23.4999 19.357 23.4076 19.5795 23.2436 19.7436C23.0795 19.9076 22.857 19.9999 22.625 20Z'
                                            fill='#4C8147'
                                        />
                                    </svg>
                                    {unreadCount > 0 && (
                                        <span className='badge light text-white bg-primary rounded-circle'>
                                            {unreadCount}
                                        </span>
                                    )}
                                </Dropdown.Toggle>

                                <Dropdown.Menu align='right' className='mt-2'>
                                    <PerfectScrollbar className='widget-media dz-scroll p-3 height380 ps'>
                                        <ul className='timeline'>
                                            <li className='nav-item '>
                                                <div className='input-group search-area  w-100 inline-flex '>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        placeholder='Search notifications...'
                                                        value={searchQuery}
                                                        onChange={e =>
                                                            setSearchQuery(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                    <div className='input-group-append'>
                                                        <span className='input-group-text'>
                                                            <Link to='#'>
                                                                <i className='flaticon-381-search-2' />
                                                            </Link>
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>

                                            {filteredNotifications.length ===
                                            0 ? (
                                                <li className='notification-empty-state '>
                                                    <div className='text-center p-4'>
                                                        <i
                                                            className='fa fa-bell-o mb-2'
                                                            style={{
                                                                fontSize:
                                                                    '24px',
                                                                color: '#ccc',
                                                            }}
                                                        ></i>
                                                        <p className='mb-0'>
                                                            {searchQuery
                                                                ? 'No matching notifications found'
                                                                : 'No notifications yet'}
                                                        </p>
                                                    </div>
                                                </li>
                                            ) : (
                                                filteredNotifications.map(
                                                    (item, index) => {
                                                        // Format the timestamp
                                                        const date = new Date(
                                                            item.timestamp
                                                        );
                                                        const formattedDate =
                                                            date.toLocaleDateString(
                                                                'en-US',
                                                                {
                                                                    day: 'numeric',
                                                                    month: 'long',
                                                                    year: 'numeric',
                                                                }
                                                            );
                                                        const formattedTime =
                                                            date.toLocaleTimeString(
                                                                'en-US',
                                                                {
                                                                    hour: '2-digit',
                                                                    minute: '2-digit',
                                                                }
                                                            );

                                                        // Determine icon/initials based on notification type

                                                        return (
                                                            <li
                                                                key={item.id}
                                                                className={
                                                                    !item.is_seen
                                                                        ? 'unread-notification'
                                                                        : ''
                                                                }
                                                            >
                                                                <div
                                                                    className='timeline-panel'
                                                                    onClick={() =>
                                                                        handleNotificationClick(
                                                                            item
                                                                        )
                                                                    }
                                                                >
                                                                    <div className='media mr-2 media-primary'>
                                                                        <i className='fa fa-bell fa-'></i>
                                                                    </div>
                                                                    <div className='media-body'>
                                                                        <h6 className='mb-1'>
                                                                            {
                                                                                item.title
                                                                            }
                                                                        </h6>

                                                                        {item.endpoint &&
                                                                            item
                                                                                .endpoint
                                                                                .bookid && (
                                                                                <p className='mb-1'>
                                                                                    <strong>
                                                                                        Book
                                                                                        ID:
                                                                                    </strong>{' '}
                                                                                    {
                                                                                        item
                                                                                            .endpoint
                                                                                            .bookid
                                                                                    }
                                                                                </p>
                                                                            )}
                                                                        <small className='d-block'>
                                                                            {
                                                                                formattedDate
                                                                            }{' '}
                                                                            -{' '}
                                                                            {
                                                                                formattedTime
                                                                            }
                                                                        </small>
                                                                    </div>
                                                                    {!item.is_seen && (
                                                                        <span className='badge badge-primary notification-badge'></span>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        );
                                                    }
                                                )
                                            )}
                                        </ul>
                                        <div
                                            className='ps__rail-x'
                                            style={{left: 0, bottom: 0}}
                                        >
                                            <div
                                                className='ps__thumb-x'
                                                tabIndex={0}
                                                style={{left: 0, width: 0}}
                                            />
                                        </div>
                                        <div
                                            className='ps__rail-y'
                                            style={{top: 0, right: 0}}
                                        >
                                            <div
                                                className='ps__thumb-y'
                                                tabIndex={0}
                                                style={{top: 0, height: 0}}
                                            />
                                        </div>
                                    </PerfectScrollbar>
                                    <div className='notification-actions d-flex justify-content-between p-3 border-top'>
                                        <Link
                                            className='mark-all-read'
                                            to='#'
                                            onClick={async () => {
                                                try {
                                                    // Get all unread notifications
                                                    const unreadNotifications =
                                                        notificationData.filter(
                                                            item =>
                                                                !item.is_seen
                                                        );

                                                    if (
                                                        unreadNotifications.length >
                                                        0
                                                    ) {
                                                        // Update each unread notification in the backend
                                                        await Promise.all(
                                                            unreadNotifications.map(
                                                                notification =>
                                                                    seenNotification(
                                                                        notification.id
                                                                    )
                                                            )
                                                        );

                                                        // Update UI
                                                        const updatedNotifications =
                                                            notificationData.map(
                                                                item => ({
                                                                    ...item,
                                                                    is_seen: true,
                                                                })
                                                            );
                                                        setNotificationData(
                                                            updatedNotifications
                                                        );
                                                        setFilteredNotifications(
                                                            updatedNotifications
                                                        );
                                                        setUnreadCount(0);
                                                    }
                                                } catch (error) {
                                                    console.error(
                                                        'Error marking all notifications as read:',
                                                        error
                                                    );
                                                }
                                            }}
                                        >
                                        </Link>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown
                                onClick={e => e.stopPropagation()}
                                className='nav-item dropdown header-profile'
                                as='li'
                                show={showDropdown}
                                onToggle={handleDropdownToggle}
                            >
                                <Dropdown.Toggle
                                    as='a'
                                    to='#'
                                    variant=''
                                    className='nav-link  i-false p-0c-pointer pointr'
                                >
                                    <img
                                        src={profileSrc}
                                        width={20}
                                        onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = avatar; }}
                                        alt='profile'
                                    />
                                    
                                </Dropdown.Toggle>
                                <Dropdown.Menu align='right' className='mt-2'>
                                    <Link
                                        to='/app-profile'
                                        className='dropdown-item ai-icon'
                                        onClick={handleDropdownItemClick}
                                    >
                                        <svg
                                            id='icon-user1'
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='text-primary'
                                            width={18}
                                            height={18}
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='currentColor'
                                            strokeWidth={2}
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                        >
                                            <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' />
                                            <circle cx={12} cy={7} r={4} />
                                        </svg>
                                        <span className='ml-2'>Profile </span>
                                    </Link>
                                    {/* <Link */}
                                    {/*     to='/email-inbox' */}
                                    {/*     className='dropdown-item ai-icon' */}
                                    {/* > */}
                                    {/*     <svg */}
                                    {/*         id='icon-inbox' */}
                                    {/*         xmlns='http://www.w3.org/2000/svg' */}
                                    {/*         className='text-success' */}
                                    {/*         width={18} */}
                                    {/*         height={18} */}
                                    {/*         viewBox='0 0 24 24' */}
                                    {/*         fill='none' */}
                                    {/*         stroke='currentColor' */}
                                    {/*         strokeWidth={2} */}
                                    {/*         strokeLinecap='round' */}
                                    {/*         strokeLinejoin='round' */}
                                    {/*     > */}
                                    {/*         <path d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' /> */}
                                    {/*         <polyline points='22,6 12,13 2,6' /> */}
                                    {/*     </svg> */}
                                    {/*     <span className='ml-2'>Inbox </span> */}
                                    {/* </Link> */}
                                    <div onClick={handleDropdownItemClick}>
                                        <Logout />
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        userProfile: state.user,
    };
};

export default connect(mapStateToProps)(Header);
